window._ = require('lodash');
export default window._
